import { render, staticRenderFns } from "./DragList.vue?vue&type=template&id=54854256&scoped=true&"
import script from "./DragList.vue?vue&type=script&lang=js&"
export * from "./DragList.vue?vue&type=script&lang=js&"
import style0 from "./DragList.vue?vue&type=style&index=0&id=54854256&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54854256",
  null
  
)

export default component.exports